import React, { Component, Fragment } from "react";
import {
  Grid,
  List,
  Hidden,
  Slide
} from '@material-ui/core';

import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import Pane from './containers/Pane';
import { FilterTabs } from './containers/FilterTabs';
import DetailsCard from './containers/DetailsCard';
import DetailsCardModal from './containers/DetailsCardModal';
import { LoadingProgress } from './containers/LoadingProgress';
import { EventDetail } from './EventDetail';
import { EventItem } from './EventItem';

import { Filters } from './../services/Filters';

const _filters = new Filters();

class Events extends Component {

  state = {
    selectedFilter: 0,
    open: false,
    enter: false,
  }


  componentDidMount() {
    // this.props.onRefreshData();
  }

  componentWillUnmount() {
    this.props.onClose();
  }

  getEventsByFilter() {

    if(this.props.type === 'cals') {
      return Object.entries(
        this.props.events.reduce((events, filter) => {
          const {calendar_id} = filter;
          events[calendar_id] = events[calendar_id]
          ? [...events[calendar_id], filter]
          : [filter]

          return events;
        }, {})
      );
    } else {
      return Object.entries(
        this.props.events.reduce((events, event) => {
          const filtersArray = event.filters.split("|");
          for(let i = 0; i < filtersArray.length; i++) {
            events[filtersArray[i]] = events[filtersArray[i]]
            ? [...events[filtersArray[i]], event]
            : [event]
          }
  
          return events;
        }, {})
      );
    }
  }

  handleFilterSelected = selectedFilter => {
    this.setState({
      selectedFilter
    });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleOnEnter = () => {
    this.setState({enter: true});
  }
  handleOffEnter = () => {
    this.setState({enter: false});
  }

  handleClose = () => {
    const transitionDelay = isWidthUp('md', this.props.width) ? 300 : 0;
    this.handleOffEnter();
    setTimeout(() => {
      this.setState({ open: false });
      this.props.onClose();
    },transitionDelay);
  };

  handleSelect = (id) => {
    this.props.onSelect(id);
    this.handleOnEnter();
    if (!isWidthUp('md', this.props.width)) {
      this.handleOpen();
    }
  }

  onExternalLink = (e, url) => {
    e.preventDefault();
    window.open(url);
  }

  handleItemClick = (e, url, id) => {
    if(url) {
      this.onExternalLink(e, url);
    } else {
      this.handleSelect(id);
    }
  }

  render() {
      // for filters when manual or multi calendar but not single cal or no filters
      const calendars = this.props.filters
        ? this.props.type === 'cals' && this.props.filters.length > 1
          ? this.props.filters
          : this.props.type === 'manual' && this.props.filters.length > 0
          ? this.props.filters
          : null
        : null;
      const { selectedFilter, enter } = this.state;
      const eventsData = this.props.events;
      const {
        translations,
        appLanguage,
        eventItem: {
          id,
          header,
          description,
          location,
          start_ts,
          end_ts,

        }
      } = this.props;

      const eventItems = selectedFilter
      ? this.getEventsByFilter().map(([filter, events], i) => {
        return selectedFilter.toString() === filter
        ? events.map((item) => {
          return (
            <EventItem
              key={item.id ? item.id : 0}
              item={item}
              onClick={this.handleItemClick}
            />
          )
        }) : null
      })
      : eventsData.map((item) => {
        return (
          <EventItem
            key={item.id ? item.id : 0}
            item={item}
            onClick={this.handleItemClick}
            itemCategory={calendars ? calendars[item.calendar_id -1] : null}
          />
        )
      });


    return (
      <Fragment>
        <Grid container spacing={24} justify="center" alignItems='stretch'>
          <Grid item xs zeroMinWidth style={{maxWidth: 800}}>
            <Pane
              header={translations.t_TITLE_EVENTS[appLanguage]}
              filterTabs={ calendars !== null ?
                <FilterTabs
                  filters={calendars}
                  selectedFilter={selectedFilter}
                  onFilterSelect={this.handleFilterSelected}
                />
                : null
              }  
            > 
              <LoadingProgress data={eventsData}>
                <List>
                  {eventItems}
                </List>
              </LoadingProgress>
            </Pane>
          </Grid>
          { id ? 
            <Fragment>
              <Hidden smDown>
                <Grid item xs lg={5}>
                  <Slide direction="left" in={enter} mountOnEnter unmountOnExit>
                    <DetailsCard
                      title={header}
                      appLanguage={appLanguage}
                      subheader={_filters.startEndDate(start_ts, end_ts)}
                      onClose={this.handleClose}
                    >
                      <EventDetail
                        description={description}
                        location={location}
                        translations={translations}
                        appLanguage={appLanguage}
                      />
                    </DetailsCard>
                  </Slide>
                </Grid>
              </Hidden>
              <DetailsCardModal
                ariaLabelledby="notice-modal-title"
                ariaDescribedby="notice-modal-description"
                appLanguage={appLanguage}
                open={this.state.open}
                onClose={this.handleClose}
                title={header}
                subheader={_filters.startEndDate(start_ts, end_ts)}
              >
                <EventDetail
                  description={description}
                  location={location}
                  translations={translations}
                  appLanguage={appLanguage}
                />
              </DetailsCardModal>
            </Fragment>
            : null
          }
        </Grid>
      </Fragment>
    );
  }

}

export default withWidth()(Events);


// WEBPACK FOOTER //
// ./src/components/Events.js